import apiCall from 'utils/axios';

import { notifyWithSnack } from './notifications';

// actions
export const SET_CURRENT_CLASSROOM_LOADED = 'mus/SET_CURRENT_CLASSOOM/LOADED';
export const SET_CURRENT_MISSION_LOADED = 'mus/SET_CURRENT_MISSION/LOADED';

export const GET_MISSION_PROGRESS_LOADING = 'mus/GET_MISSION_PROGRESS/LOADING';
export const GET_MISSION_PROGRESS_LOADED = 'mus/GET_MISSION_PROGRESS/LOADED';
export const GET_MISSION_PROGRESS_FAILED = 'mus/GET_MISSION_PROGRESS/FAILED';

export const GET_PART_PROGRESS_LOADING = 'mus/GET_PART_PROGRESS/LOADING';
export const GET_PART_PROGRESS_LOADED = 'mus/GET_PART_PROGRESS/LOADED';
export const GET_PART_PROGRESS_FAILED = 'mus/GET_PART_PROGRESS/FAILED';

export const CREATE_STUDENTS_LOADING = 'mus/CREATE_STUDENTS/LOADING';
export const CREATE_STUDENTS_LOADED = 'mus/CREATE_STUDENTS/LOADED';
export const CREATE_STUDENTS_FAILED = 'mus/CREATE_STUDENTS/FAILED';

export const GET_ASSESSMENT_PROGRESS_LOADING = 'mus/GET_ASSESSMENT_PROGRESS/LOADING';
export const GET_ASSESSMENT_PROGRESS_LOADED = 'mus/GET_ASSESSMENT_PROGRESS/LOADED';
export const GET_ASSESSMENT_PROGRESS_FAILED = 'mus/GET_ASSESSMENT_PROGRESS/FAILED';

export const SET_OPERATING_CLASSROOM_LOADING = 'mus/SET_OPERATING_CLASSROOM_LOADING/LOADING';
export const SET_OPERATING_CLASSROOM_LOADED = 'mus/SET_OPERATING_CLASSROOM_LOADED/FAILED';
export const SET_OPERATING_CLASSROOM_FAILED = 'mus/SET_OPERATING_CLASSROOM_FAILED/LOADED';

// action creators
export const setCurrentClassroom = (payload) => ({ type: SET_CURRENT_CLASSROOM_LOADED, payload });
export const setCurrentMission = (payload) => ({ type: SET_CURRENT_MISSION_LOADED, payload });

export const getMissionProgressLoading = () => ({ type: GET_MISSION_PROGRESS_LOADING });
export const getMissionProgressLoaded = (payload) => ({ type: GET_MISSION_PROGRESS_LOADED, payload });
export const getMissionProgressFailed = () => ({ type: GET_MISSION_PROGRESS_FAILED });

export const getPartProgressLoading = () => ({ type: GET_PART_PROGRESS_LOADING });
export const getPartProgressLoaded = (payload) => ({ type: GET_PART_PROGRESS_LOADED, payload });
export const getPartProgressFailed = () => ({ type: GET_PART_PROGRESS_FAILED });

export const getCreateStudentsLoading = () => ({ type: CREATE_STUDENTS_LOADING });
export const getCreateStudentsLoaded = (payload) => ({ type: CREATE_STUDENTS_LOADED, payload });
export const getCreateStudentsFailed = () => ({ type: CREATE_STUDENTS_FAILED });

export const getAssessmentProgressLoading = () => ({ type: GET_ASSESSMENT_PROGRESS_LOADING });
export const getAssessmentProgressLoaded = (payload) => ({ type: GET_ASSESSMENT_PROGRESS_LOADED, payload });
export const getAssessmentProgressFailed = () => ({ type: GET_ASSESSMENT_PROGRESS_FAILED });

export const setOperatingClassroomLoading = () => ({ type: SET_OPERATING_CLASSROOM_LOADING });
export const setOperatingClassroom = (payload) => ({ type: SET_OPERATING_CLASSROOM_LOADED, payload });
export const setOperatingClassroomFailed = () => ({ type: SET_OPERATING_CLASSROOM_FAILED });

// side effects
export const createStudents = (payload, onSuccess) => (dispatch) =>
  apiCall({ url: '/students/batch', method: 'POST', data: payload })
    .then(({ data }) => {
      dispatch(getCreateStudentsLoaded(data));
      onSuccess?.(data);
      return Promise.resolve(data);
    })
    .catch((err) => {
      console.log({ err });
      dispatch(getCreateStudentsFailed());
      dispatch(notifyWithSnack({ message: err.message, type: 'error' }));
    });

export const getMissionProgress = (classId, missionId) => (dispatch) =>
  apiCall({ url: `/classrooms/${classId}/missions/${missionId}` })
    .then(({ data }) => {
      dispatch(getMissionProgressLoaded(data));
    })
    .catch((err) => {
      dispatch(getMissionProgressFailed());
    });

export const getPartProgress = (classId, missionId, partId) => (dispatch) => {
  dispatch(getPartProgressLoading());
  return apiCall({ url: `/classrooms/${classId}/missions/${missionId}/parts/${partId}` })
    .then(({ data }) => {
      dispatch(getPartProgressLoaded({ ...data.part_progresses }));
    })
    .catch((err) => dispatch(getPartProgressFailed()));
};

export const getAssessmentProgress = (classId, missionId, partId) => (dispatch) => {
  dispatch(getAssessmentProgressLoading());
  return apiCall({ url: `/classrooms/${classId}/missions/${missionId}/parts/${partId}/quiz` })
    .then(({ data }) => {
      dispatch(getAssessmentProgressLoaded(data.quiz));
    })
    .catch((err) => dispatch(getAssessmentProgressFailed()));
};

export const getClassCode = () => (dispatch) =>
  apiCall({ url: '/classrooms/code_generate' })
    .then(({ data }) => data)
    .catch(() => dispatch(notifyWithSnack({ message: `Couldn't generate new code. Try again.`, type: 'error' })));
